<template>
    <div>
        <Button type="primary" @click="showAddStudentModal" size="small" style="margin-bottom:10px">添加学员</Button>
        <Table :columns="students.columns" :data="students.data">
            <template slot-scope="{ row, index }" slot="hour_num">
                <div v-if="row.student_hour_num!=null">{{row.student_hour_num}}</div>
                <div v-else>{{row.class_hour_num}}</div>
            </template>
            <template slot-scope="{ row, index }" slot="state">
                <div v-if="row.state==1"><Tag color="success">正常</Tag></div>
                <div v-else-if="row.state==2"><Tag color="error">已停课</Tag></div>
                <div v-else-if="row.state==3"><Tag color="default">已结课</Tag></div>
                <div v-else-if="row.state==4"><Tag color="default">已转出</Tag></div>
                <div v-else>异常</div>
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <Button @click="$xmutils.gotoStudentDetail(row.id,$router)" type="info" size="small" style="margin-right: 5px">学员详情</Button>
                <Button @click="studentClassRecordList(row)" type="info" size="small" style="margin-right: 5px">课程</Button>
                <Button @click="studentStop(row)" v-if="detailForm.state == 1 && row.state == 1" type="info" size="small" style="margin-right: 5px">停课</Button>
                <Button @click="showEditStudentModal(row)" v-if="detailForm.state == 1 &&  row.state == 2 && row.class_num_remain > 0" type="info" size="small" style="margin-right: 5px">恢复上课</Button>
                <Button @click="showTransModal(row)" type="info" size="small" style="margin-right: 5px" v-if="detailForm.state == 1 && row.state <=1">转班</Button>
                <Button @click="showSetHourNumModal(row)" type="info" size="small">设置扣课数</Button>
            </template>
        </Table>
        <studentClassRecord ref="studentClassRecord" :clazzId="clazzId" ></studentClassRecord>
        <Modal v-model="showEditStudentModalFlag" :title="editStudentModalTitle"  width="800">
            <Form :model="editStudentForm" :label-width="100" @keyup.enter.native="editStudentFormSubmit()">
                <Row>
                    <Col span="12">
                        <FormItem label="学员" class="ivu-form-item-required">
                            <Select v-model="editStudentForm.studentId" v-if="editStudentType == 1" filterable  clearable>
                                <Option v-for="student in beAddedStudentList"  :value="student.id" :key="student.id" >{{student.name }}</Option>
                            </Select>
                            <div v-else>
                                {{editStudentForm.studentName}}
                            </div>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem label="开始上课时间" class="ivu-form-item-required">
                            <DatePicker :value="editStudentForm.startDate" type="date" placeholder="选择上课时间" style="width: 300px"
                                        format="yyyy-MM-dd" @on-change="editStudentForm.startDate=$event"></DatePicker>
                        </FormItem>
                    </Col>
                </Row>

            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="editStudentModalCancel">取消</Button>
                <Button type="primary" size="large" @click="editStudentFormSubmit" :loading="editStudentSaving">
                    确定
                </Button>
            </div>
        </Modal>
        <Modal v-model="showTransModalFlag" title="学员转班"  width="800">
            <Form :model="editTransForm" :label-width="100" @keyup.enter.native="editTransFormSubmit()">
                <Row>
                    <Col span="12">
                        <FormItem label="学员" class="ivu-form-item-required">
                            {{editTransForm.studentName}}
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem label="新班级" class="ivu-form-item-required">
                            <Select v-model="editTransForm.classId" filterable style="width: 280px">
                                <Option v-for="item in classList" :value="item.id" :key="item.id">{{item.zoneName}}-{{ item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem label="开始上课时间" class="ivu-form-item-required">
                            <DatePicker :value="editTransForm.startDate" type="date" placeholder="选择上课时间" style="width: 300px"
                                        format="yyyy-MM-dd" @on-change="editTransForm.startDate=$event"></DatePicker>
                        </FormItem>
                    </Col>
                </Row>

            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="editTransModalCancel">取消</Button>
                <Button type="primary" size="large" @click="editTransFormSubmit" :loading="editTransSaving">
                    确定
                </Button>
            </div>
        </Modal>
        <Modal v-model="showHourNumModalFlag" title="">
            <Form :model="hourNumForm" :label-width="150" @keyup.enter.native="editHourNumFormSubmit()">
                <Row>
                    <Col span="20">
                        <FormItem label="每节课扣多少课时" class="ivu-form-item-required">
                            <Input v-model="hourNumForm.num" placeholder="默认与班级设置一致" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="editHourNumModalCancel">取消</Button>
                <Button type="warning" size="large" @click="resetHourNumFormSubmit" :loading="editHourNumSaving">
                    设置为与班级扣课时数一致
                </Button>
                <Button type="primary" size="large" @click="editHourNumFormSubmit" :loading="editHourNumSaving">
                    确定
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
  import studentClassRecord from './studentClassRecord'

  export default {
    name: 'clazz_students',
    props: {
      detailForm: Object,
      clazzId: Number,
    },
    components: {
      studentClassRecord
    },
    data() {
      return {
        studentId:null,
        students:{
          columns:[
            {
              title:'姓名',
              key:'name',
              align:'center'
            },
            {
              title:'已用课时',
              key:'class_num_used',
              align:'center'
            },
            {
              title:'剩余课时',
              key:'class_num_remain',
              align:'center'
            },
            {
              title:'剩余排课',
              key:'remainnum',
              align:'center'
            },
            {
              title:'每节课扣课数',
              align:'center',
              slot:'hour_num'
            },
            {
              title:'状态',
              align:'center',
              slot:'state'
            },
            {
              title:'操作',
              slot:'action',
              width:380
            }
          ],
          data:[]
        },
        showEditStudentModalFlag:false,
        editStudentModalTitle:null,
        editStudentType:null,
        editStudentForm:{
          studentId:null,
          studentName:null,
          startDate:null
        },
        editTransForm:{
          studentId:null,
          studentName:null,
          startDate:null,
          classId:null
        },
        beAddedStudentList:[],
        editStudentSaving:false,
        showHourNumModalFlag:false,
        hourNumForm:{
          class_student_id:null,
          num:null
        },
        editHourNumSaving:false,
        showTransModalFlag:false,
        editTransSaving:false,
        classList:[]
      }
    },
    mounted:function(){
      this.$api.clazz.getTransTargetAvailableMultiClass({
        classId:this.clazzId
      }).then(resp => {
        if (resp.state == 'ok'){
          this.classList = resp.data;
        }else{
          this.$Message.error(resp.msg)
        }
      });
    },
    methods: {
      getStudents: function () {
        this.students.data = [];
        this.$api.clazz.getStudentList({id: this.clazzId}).then(res => {
          if (res.state == "ok") {
            this.students.data = res.data;
            this.$emit('changeStudentNum',this.students.data.length)
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      studentClassRecordList:function(row){
        this.$refs.studentClassRecord.showModal(row.id)
      },
      studentStop:function(row){
        let self = this;
        self.$Modal.confirm({
          title: '确认操作',
          content: '确认要对学员<span style="color:red">【'+row.name+'】</span>执行停课操作吗?将删除该学员已排课程（课时保留 ）',
          onOk() {
            this.$api.clazz.studentStop({clazzId: self.clazzId,studentId:row.id}).then(res => {
              if (res.state == "ok") {
                self.$Message.success("停课课操作成功")
                self.getStudents()
              } else {
                self.$Message.error(res.msg)
              }
            })
          },
          onClose() {
          }
        })
      },
      showAddStudentModal(){
        this.$api.clazz.getBeAddedStudentList({clazzId:this.clazzId}).then(res => {
          if (res.state == "ok") {
            this.beAddedStudentList = res.data;
            this.editStudentType = 1;
            this.editStudentModalTitle = '添加学员';
            this.editStudentForm = {studentId:null,startDate:null,studentName:null};
            this.showEditStudentModalFlag = true;
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      showSetHourNumModal(student){
        this.hourNumForm.class_student_id = student.class_student_id;
        this.hourNumForm.num = student.student_hour_num;
        this.showHourNumModalFlag = true;
      },
      showEditStudentModal(student){
        this.editStudentType = 2;
        this.editStudentForm.studentId = student.id;
        this.editStudentForm.startDate = null;
        this.editStudentForm.studentName = student.name;
        this.editStudentModalTitle = '停课学员重新上课';
        this.showEditStudentModalFlag = true;
      },
      showTransModal(student){
        this.editTransForm.studentId = student.id;
        this.editTransForm.startDate = null;
        this.editTransForm.classId = null;
        this.editTransForm.studentName = student.name;
        this.showTransModalFlag = true;
      },
      editStudentFormSubmit(){
        if (!this.editStudentForm.studentId){
          this.$Message.error("请选择学员")
          return;
        }
        if (!this.editStudentForm.startDate){
          this.$Message.error("请选择开始上课时间")
          return;
        }
        this.editStudentSaving = true;
        this.$api.clazz.addStudent({studentId:this.editStudentForm.studentId,startDate:this.editStudentForm.startDate, clazzId:this.clazzId}).then(res => {
          this.editStudentSaving = false;
          if (res.state == "ok") {
            if (this.editStudentType == 1){
              this.$Message.info('添加成功');
            }else{
              this.$Message.info('恢复成功');
            }

            this.showEditStudentModalFlag = false;
            this.getStudents();
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      editTransFormSubmit(){
        if (!this.editTransForm.studentId){
          this.$Message.error("请选择学员")
          return;
        }
        if (!this.editTransForm.classId){
          this.$Message.error("请选择新班级")
          return;
        }
        if (!this.editTransForm.startDate){
          this.$Message.error("请选择开始上课时间")
          return;
        }
        this.editTransSaving = true;
        this.$api.clazz.transStudent({studentId:this.editTransForm.studentId,startDate:this.editTransForm.startDate, clazzId:this.clazzId,targetClassId:this.editTransForm.classId}).then(res => {
          this.editStudentSaving = false;
          if (res.state == "ok") {
            this.$Message.info('转班操作成功');
            this.showTransModalFlag = false;
            this.getStudents();
          } else {
            this.$Message.error(res.msg)
          }
          this.editTransSaving = false;
        })
      },
      editStudentModalCancel(){
        this.beAddedStudentList = [];
        this.editStudentSaving = false;
        this.editStudentModalTitle = '';
        this.showEditStudentModalFlag = false;
      },
      editTransModalCancel(){
        this.editTransForm.studentId = null;
        this.editTransForm.startDate = null;
        this.editTransForm.classId = null;
        this.editTransForm.studentName = null;
        this.showTransModalFlag = false;
      },
      editHourNumFormSubmit(){
        if (!this.hourNumForm.class_student_id){
          this.$Message.error("请选择学员")
          return;
        }
        if (!this.hourNumForm.num){
          this.$Message.error("请输入课时数")
          return;
        }
        this.editHourNumSaving = true;
        this.$api.clazz.setStudentHourNum({class_student_id:this.hourNumForm.class_student_id,num:this.hourNumForm.num}).then(res => {
          this.editHourNumSaving = false;
          if (res.state == "ok") {
            this.$Message.info('设置成功');
            this.editHourNumSaving = false;
            this.showHourNumModalFlag = false;
            this.getStudents();
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      editHourNumModalCancel(){
        this.editHourNumSaving = false;
        this.showHourNumModalFlag = false;
      },
      resetHourNumFormSubmit(){
        this.$api.clazz.resetStudentHourNum({class_student_id:this.hourNumForm.class_student_id}).then(res => {
          this.editHourNumSaving = false;
          if (res.state == "ok") {
            this.$Message.info('设置成功');
            this.editHourNumSaving = false;
            this.showHourNumModalFlag = false;
            this.getStudents();
          } else {
            this.$Message.error(res.msg)
          }
        })
      }
    },
    filters:{

    },

  }
</script>
